import React from "react";
import { Box, Typography } from "@mui/material";
import MarkdownRenderer from "../../MarkdownRenderer";

type SocialMediaIntakeAgentProps = {
  parsedContent: any;
};

export default function SocialMediaIntakeAgent({
  parsedContent,
}: SocialMediaIntakeAgentProps): JSX.Element {
  const finalAnswer = parsedContent?.finalAnswer;

  if (!finalAnswer) {
    return <Typography>No data available</Typography>;
  }

  const type = finalAnswer.type;
  const title = finalAnswer.title;
  const description = finalAnswer.description;
  const options = finalAnswer.options;
  const question = finalAnswer.question;
  const payload = finalAnswer.payload;

  // Handle confirmation type with payload
  if (type === "confirmation" && payload) {
    return (
      <div>
        {/* {title && (
          <h3
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#004141",
              margin: 0,
              marginBottom: "20px",
            }}
          >
            {title}
          </h3>
        )} */}

        {/* Channels */}
        {payload.channels && payload.channels.length > 0 && (
          <Box sx={{ marginBottom: "16px" }}>
            <Typography
              sx={{
                fontSize: "16px !important",
                color: "#004141",
                fontWeight: 600,
              }}
            >
              Channels: {payload.channels.join(", ")}
            </Typography>
          </Box>
        )}

        {/* Focus Areas */}
        {payload.focus_areas && payload.focus_areas.length > 0 && (
          <Box sx={{ marginBottom: "16px" }}>
            <Typography
              sx={{
                fontSize: "16px !important",
                fontWeight: "600",
                color: "#004141",
                marginBottom: "8px",
              }}
            >
              Focus Areas:
            </Typography>
            <ul
              style={{
                margin: 0,
                paddingLeft: "20px",
                listStyleType: "disc",
              }}
            >
              {payload.focus_areas.map((area: string, index: number) => (
                <li
                  key={index}
                  style={{
                    fontSize: "15px",
                    color: "#004141",
                    lineHeight: "1.8",
                    marginBottom:
                      index < payload.focus_areas.length - 1 ? "6px" : 0,
                  }}
                >
                  {area}
                </li>
              ))}
            </ul>
          </Box>
        )}

        {/* Post Type */}
        {payload.post_type && (
          <Box sx={{ marginBottom: "16px" }}>
            <Typography
              sx={{
                fontSize: "16px !important",
                color: "#004141",
              }}
            >
              <strong>Post Type:</strong> {payload.post_type}
              {payload.num_series_posts &&
                ` (${payload.num_series_posts} posts)`}
            </Typography>
          </Box>
        )}

        {/* Suggestions */}
        {payload.suggestions && (
          <Box sx={{ marginBottom: "16px" }}>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#004141",
                marginBottom: "8px",
              }}
            >
              Additional Suggestions:
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                color: "#004141",
              }}
            >
              {payload.suggestions}
            </Typography>
          </Box>
        )}

        {/* Description at the end */}
        {description && (
          <p
            style={{
              fontSize: "16px",
              fontWeight: 600,
              color: "#004141",
              margin: 0,
              marginTop: "20px",
              lineHeight: "1.6",
            }}
          >
            {description}
          </p>
        )}
      </div>
    );
  }

  // If title and description exist, render them
  if (title || description) {
    return (
      <div>
        {/* {title && (
          <h3
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#004141",
              margin: 0,
              marginBottom: description ? "12px" : 0,
            }}
          >
            {title}
          </h3>
        )} */}
        {description && (
          <p
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#004141",
              margin: 0,
              lineHeight: "1.6",
              marginBottom: options && options.length > 0 ? "16px" : 0,
            }}
          >
            {description}
          </p>
        )}
        {options && options.length > 0 && (
          <Box>
            <ul
              style={{
                margin: 0,
                paddingLeft: "20px",
                listStyleType: "disc",
              }}
            >
              {options.map((option: string, index: number) => (
                <li
                  key={index}
                  style={{
                    fontSize: "15px",
                    color: "#004141",
                    lineHeight: "1.8",
                    marginBottom: index < options.length - 1 ? "8px" : 0,
                  }}
                >
                  {option}
                </li>
              ))}
            </ul>
          </Box>
        )}
      </div>
    );
  }

  // Fallback for question type
  if (question) {
    return (
      <div>
        <MarkdownRenderer content={question} />
      </div>
    );
  }

  return <Typography>No data available</Typography>;
}
